import React from "react";
import hero from "../assets/img/Industries/Food_hero.jpg";
import food_sub_1 from "../assets/img/Industries/food_sub_1.png";
import food_sub_2 from "../assets/img/Industries/food_sub_2.png";
import DownloadBrochure from "./DownloadBrochure";
import { Link as RouterLink } from 'react-router-dom';


const FoodIndustry = () => {

    return (
        <div className='portifoliobody'>
            <main id="main">
                <section id="pharma" className="about text-start" style={{paddingTop:'40px'}}>
                    <div className="ph-hero">
                        <div className="ph-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <div className="ph-title-content">
                                <h1>Advanced LIMS for Food & Beverage Research, Quality Control, Production Excellence.</h1>
                                <p>Drive Innovation, Optimize Production, and Ensure Compliance with a Seamless Lab Iconics LIMS Solution.</p>
                            </div>
                            <div className="book_a_demo">
                                <RouterLink to='/demo'> 
                                    <button className="book_a_demo_btn">Get a Demo</button>
                                </RouterLink>
                            </div>
                        </div>
                        <div className="ph-hero-img  carousel-container animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                            <img src={hero} alt="pharma lab" />
                        </div>
                    </div>

                    <div className="section-container" style={{marginTop:'0'}}>
                        <div className="row">
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={food_sub_1} alt="pharma lab"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Optimizing Food & Beverage Research and Development</h1></div>
                                        <ul>
                                            <li><b>Accelerated Product Innovation – </b> Streamline R&D workflows, formulation development, and ingredient testing to bring new products to market faster.</li>
                                            <li><b>Comprehensive Quality Assurance – </b>Ensure product consistency with automated <b>sample tracking, batch testing, and real-time monitoring</b> of critical parameters.</li>
                                            <li><b>Regulatory Compliance & Data Integrity  – </b>Maintain compliance with <b>FDA, ISO 22000, FSMA, HACCP, and GFSI</b> through audit trails, electronic signatures, and secure data management.</li>
                                            <li><b>Ingredient & Allergen Tracking – </b> Monitor ingredient sourcing, allergens, and traceability to meet labeling regulations and prevent cross-contamination risks.</li>
                                            <li><b>Advanced Data Analytics & Reporting – </b>Gain actionable insights with customizable dashboards, trend analysis, and automated reporting for data-driven decision-making.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sec-out" style={{paddingTop:'2rem'}}>
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={food_sub_2} alt="pharma lab"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Enhancing Production Efficiency & Supply Chain Management</h1></div>
                                        <ul>
                                            <li><b>Seamless Batch & Inventory Management – </b> Track raw materials, work-in-progress, and finished goods to optimize production and minimize waste.</li>
                                            <li><b>Automated Process Monitoring – </b> Integrate with lab instruments and production systems to monitor temperature, pH, moisture, and other critical parameters in real time.</li>
                                            <li><b>Supplier & Compliance Audits – </b> Manage supplier qualifications, perform audits, and ensure ingredient safety and regulatory adherence throughout the supply chain.</li>
                                            <li><b>Scalable & Cloud-Enabled Solution – </b> Support multi-site operations with a <b>cloud-based LIMS</b>, enabling remote access and enterprise-wide standardization.</li>
                                            <li><b>Robust Security & Role-Based Access – </b>Protect sensitive formulations and proprietary data with encryption, multi-level access controls, and compliance-driven security protocols.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </main>
            <div data-aos="fade-up" data-aos-delay="100">
                <DownloadBrochure product={'Industries'}/>
            </div>
                
        </div>
    )
}

export default FoodIndustry;